import { UnitHistoryForm } from './types';

export function isUnitHistoryFormValid(unitHistoryForm: UnitHistoryForm): boolean {
    return !!(
        unitHistoryForm.dateRange &&
        (unitHistoryForm.unitOption || unitHistoryForm.userOption) &&
        !(unitHistoryForm.unitOption && unitHistoryForm.userOption)
    );
}
